/*
 * @Descripttion: 
 * @version: 
 * @Author: wangz
 * @Date: 2019-11-21 14:58:03
 * @LastEditors: hanzb
 * @LastEditTime: 2020-04-02 14:24:14
 */
/*  资源文件提供者
 归属：企通前端平台-ECP V5.1
 版权：2014-2020 企通软件技术有限公司
 --------------------------------------------------------------------------------
 作者：王哲                           创建日期：2014/03/13
 修改：                               修改日期：
 修改内容
 --------------------------------------------------------------------------------
 文本资源 这里向使用者提供根据代码ID，获得数据字典的方法getTR(rpID)
 图片资源 这里向使用者提供根据代码ID，获得数据字典的方法getIR(rpID)
 声音资源 这里向使用者提供根据代码ID，获得数据字典的方法getVR(rpID)
 图像资源 这里向使用者提供根据代码ID，获得数据字典的方法getMR(rpID)

 !!!! 目前采用程序直接量的方式定义各种代码，最终将改为从参数中读取，但对外接口将保持不变

 *******************************************************************************/
// import { PrmFactory } from '../sgiFactory/PrmFactory';
import * as sgiCommon from '../sgiCommon/sgiCommon';

const prmkey = 'teid';//显示名称使用方式：1-te, 2-teid

/**
 * @namespace 资源管理器
 */
let Resource = {
    /**
     * 对外接口，根据key值取得图标资源对象
     * @param {type} key
     * @returns 文本资源对象
     */
	getIR: function (key) {
		var ir;
		var ap = sgiCommon.getAP(key);
		if (!ap) {
			ir = {};
			ir.c = key;
			return ir;
		}
		//图片资源缓存对象
		var irMap = Resource[ap + "IrMap"];
		if (!irMap) {
			irMap = this.initIR(ap);
		}
		ir = irMap[key];
		if (!ir) {
			ir = {};
			ir.c = key;
			return ir;
		}
		return ir;
	},
    /**
     * 对外接口，根据key值取得文本资源对象
     * @param {type} key
     * @returns 文本资源对象
     */
	getTR: function (key) {
		var tr;
		var ap = sgiCommon.getAP(key);
		if (!ap) {
			tr = {};
			tr.te = key;
			return tr;
		}
		//文本资源缓存对象
		var trMap = Resource[ap + "TrMap"];
		if (!trMap) {
			trMap = this.initTR(ap);
		}
		tr = trMap[key];
		if (!tr) {
			tr = {};
			tr.te = key;
		}
		return tr;
	},
    /**
     * 对外接口，根据dm值取得文本资源对象
     * @param {type} dm
     * @returns 文本资源对象
     */
	getTRByPrm: function (dm) {

		//暂时不取资源文件
		if (!window.sgiConfig || !window.sgiConfig.openTResource) {
			return dm;
		}

		if (!dm.te && !dm.teid) {
			return { te: undefined };
		}

		var tr;
		var key = dm[prmkey];

		if (prmkey === "te") {//直接返回
			tr = {};
			tr.te = key;
		} else if (prmkey === "teid") {//根据id查询返回
			var ap = tool.Global.currentAP || "SD";

			var trMap = Resource[ap + "TrMap"];
			if (!trMap) {
				trMap = this.initTR(ap);
			}
			tr = trMap[key];
			if (!tr) {
				tr = {};
				tr.te = dm.te;
			}
		}
		return tr;
	},
    /**
     * 对外接口，根据key值取得CSS资源对象
     * @param {type} key
     * @returns 文本资源对象
     */
	getCR: function (key) {
		var cr;
		var ap = sgiCommon.getAP(key);
		if (!ap) {
			cr = {};
			cr.te = key;
			return cr;
		}
		//文本资源缓存对象
		var crMap = Resource[ap + "CrMap"];
		if (!crMap) {
			crMap = this.initCR(ap);
		}
		cr = crMap[key];
		if (!cr) {
			cr = {};
			cr.te = key;
		}
		return cr;
	},
    /**
     * 对外接口，根据key值取得字体图标资源对象
     * @param {type} key
     * @returns 文本资源对象
     */
	getFR: function (key) {
		var ir;
		var ap = sgiCommon.getAP(key);
		if (!ap) {
			ir = {};
			ir.c = key;
			return ir;
		}
		//图片资源缓存对象
		var frMap = Resource[ap + "FrMap"];
		if (!frMap) {
			frMap = this.initFR(ap);
		}
		fr = frMap[key];
		if (!fr) {
			fr = {};
			fr.c = key;
			return fr;
		}
		return fr;
	},
    /**
     * 加载文本资源文件缓存对象
     * @param {type} ap
     * @param {type} trMap
     * @returns {undefined}
     */
	initTR: function (ap) {

		//如果ap未设定值时从SD中取值
		ap = ap || "SD";
		var tt = "RP";
		var ss = "TR";

		var trMap = {};
		Resource[ap + "TrMap"] = trMap;
		/** 以下的结构划分没有用了 */
		//划分结构为1、普通文本，文本下以A-Z中问首字母拼音为区分，Axxx xxx为编号
		//         2、特殊文本，某特定控件或者业务描述所需一组资源。AAZZ AA为特殊文本含义缩写  ZZ为编号

		//换用新的资源表
		var rList = PrmFactory.getResourceList(ap, tt, ss);
		rList.forEach(record => {
			trMap[record.sc] = record;
		});
		// var guid = ap + "_RP_TR_0001";
		// var rpTreeJson = PrmFactory.getPrm(guid);
		// var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
		// rpArray.forEach(record => {
		//     trMap[guid + "`" + record.sc]= record;
		// });
		return trMap;
	},

    /**
     * 加载文本资源文件缓存对象
     * @param {type} ap
     * @param {type} trMap
     * @returns {undefined}
     */
	initFR: function (ap) {
		var frMap = {};
		Resource[ap + "FrMap"] = frMap;

		var guid = ap + "_RP_FR_0001";
		var rpTreeJson = PrmFactory.getPrm(guid);
		var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
		rpArray.forEach(record => {
			frMap[guid + "`" + record.sc] = record;
		});
		return frMap;
	},
    /**
     * 加载图片资源文件缓存对象
     * @param {type} ap
     * @param {type} irMap
     * @returns {undefined}
     */
	initIR: function (ap) {
		var irMap = {};
		Resource[ap + "IrMap"] = irMap;
		//划分结构为以类别化为  XXnn XX:类别缩写  nn:编号
		// 视图类UInn
		//如果ap未设定值时从SD中取值
		var guid = ap + "_RP_IR_0001";
		var rpTreeJson = PrmFactory.getPrm(guid);
		var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
		rpArray.forEach(record => {
			if (record.c && record.c.indexOf("resources") >= 0) {
				//record.c = record.c;
			} else if (record.c && record.c.indexOf("http:") >= 0) {
				//record.c = record.c;
			} else if (record.c && record.c.indexOf("https:") >= 0) {
				//record.c = record.c;
			} else if (record.c && record.c.indexOf("base64") >= 0) {
				//record.c = record.c;
			} else {
				var iconPath = "resources/images/";
				record.c = iconPath + record.c;
			}
			irMap[guid + "`" + record.sc] = record;
		});
		return irMap;
	},
    /**
     * 加载CSS资源文件缓存对象
     * @param {type} ap
     * @param {type} irMap
     * @returns {undefined}
     */
	initCR: function (ap) {
		var crMap = {};
		Resource[ap + "CrMap"] = crMap;
		//划分结构为以类别化为  XXnn XX:类别缩写  nn:编号
		// 视图类UInn
		//如果ap未设定值时从SD中取值
		var guid = ap + "_RP_CR_0001";
		var rpTreeJson = PrmFactory.getPrm(guid);
		var rpArray = sgiCommon.getLeafByPrm(rpTreeJson);
		rpArray.forEach(record => {
			crMap[guid + "`" + record.sc] = record;
		});
		return crMap;
	},
}

// 初始化
if (!window.Resource) window.Resource = Resource;
// 添加方法
else Object.assign(window.Resource, Resource);
// 导出
let wResource = window.Resource;
export { wResource as Resource };
export default wResource;


// WEBPACK FOOTER //
// ./~/rt-sd-common/sgiFactory/Resource.js